import Interstitial from './Interstitial'

export default Interstitial
// eslint-disable-next-line import/export
export * from './Interstitial'
